<template>
  <ValidationObserver v-slot="{ invalid }">
    <b-form @submit.prevent="onSubmit">
      <ValidationProvider rules="required|ext:csv" v-slot="validationContext">
        <b-form-file
          v-model="csvFile"
          :state="getValidationState(validationContext)"
          placeholder="Choisissez ou faites glisser un fichier csv..."
          drop-placeholder="Déposez le .csv ici !"
          browse-text="Parcourir"
        ></b-form-file>
        <!-- There is a bug in bootstrap-vue. Passing state to
      b-form-invalid-feedback is valid workaround (See
      https://github.com/bootstrap-vue/bootstrap-vue/issues/3545) -->
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
      <div class="mt-3">Fichier choisi: {{ csvFile ? csvFile.name : "" }}</div>
      <div class="text-right">
        <gwz-button submitButtonText="Envoyer" :disabled="invalid" />
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ext } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import GwzButton from "@/components/gwzButton";
import { mapMutations } from "vuex";
import { MESSAGE_SUCCESS_IMPORT } from "@/store/constants/messages";
import { SET_LOADING } from "@/store/constants/mutation-types";

extend("ext", {
  ...ext,
  message: "Le fichier doit être de type csv"
});

export default {
  name: "gwzCsvForm",
  components: {
    ValidationProvider,
    GwzButton,
    ValidationObserver
  },
  data() {
    return {
      csvFile: null
    };
  },
  props: {
    serviceName: {
      type: String,
      required: true
    },
    endpointName: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapMutations({ setLoading: SET_LOADING }),
    onSubmit() {
      this.setLoading(true);
      this.$gwzApi
        .service(this.serviceName)
        [this.endpointName](this.csvFile)
        .then(() => {
          this.$store.dispatch("setSuccessToast", MESSAGE_SUCCESS_IMPORT);
        })
        .catch(err => {
          this.$store.dispatch("setErrorToast", err.message);
        })
        .finally(this.setLoading(false));
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    }
  }
};
</script>

<style></style>
